import React,{useState} from 'react';
import './ContactForm.css';

const initialValues={name:'',company:'',email:'',phone:'',message:'',website:''};
const contactEndpoint='/.netlify/functions/contact';

function ContactForm() {
  const [values,setValues]=useState(initialValues);
  const [status,setStatus]=useState('idle');

  const handleChange=(event)=>{
    const {name,value}=event.target;
    setValues((current)=>({...current,[name]:value}));
  };

  const handleSubmit=async(event)=>{
    event.preventDefault();
    if (status==='sending') return;
    setStatus('sending');

    try {
      const response=await fetch(contactEndpoint,{
        method:'POST',
        headers:{
          Accept:'application/json',
          'Content-Type':'application/json'
        },
        body:JSON.stringify(values)
      });

      if (!response.ok) throw new Error('Submission failed');
      setValues(initialValues);
      setStatus('success');
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="contact-form-wrap">
      {status==='success' ? (
        <p className="contact-form-message" role="status">
          Tak for din besked. Vi vender tilbage hurtigst muligt.
        </p>
      ) : (
        <form className="contact-form" onSubmit={handleSubmit} noValidate>
          <div className="contact-form-grid">
            <label className="contact-field">
              <span>Navn</span>
              <input name="name" type="text" value={values.name} onChange={handleChange} required autoComplete="name" />
            </label>
            <label className="contact-field">
              <span>Virksomhed</span>
              <input name="company" type="text" value={values.company} onChange={handleChange} required autoComplete="organization" />
            </label>
            <label className="contact-field">
              <span>Email</span>
              <input name="email" type="email" value={values.email} onChange={handleChange} required autoComplete="email" />
            </label>
            <label className="contact-field">
              <span>Telefon <em>(valgfrit)</em></span>
              <input name="phone" type="tel" value={values.phone} onChange={handleChange} autoComplete="tel" />
            </label>
          </div>
          <label className="contact-field contact-field-message">
            <span>Besked</span>
            <textarea name="message" value={values.message} onChange={handleChange} required rows="5" />
          </label>
          <input className="contact-honeypot" name="website" type="text" value={values.website} onChange={handleChange} tabIndex="-1" autoComplete="off" aria-hidden="true" />
          {status==='error' && <p className="contact-form-error" role="alert">Der opstod en fejl. Prøv igen eller kontakt os direkte.</p>}
          <button className="contact-form-submit" type="submit" disabled={status==='sending'}>
            {status==='sending' ? 'SENDER...' : 'SEND BESKED'}
          </button>
        </form>
      )}
    </div>
  );
}

export default ContactForm;